<template>
  <div id="pretest-result">
    <div>
      <div class="end-greeting">
        <h2 class="text-center">聯絡表單</h2>
        <p>
          JYG Consulting
          專擅企業ESG健檢，協助企業找到現階段的問題，並發展出客製化ESG解決方案與策略規劃。請留下您的email，我們將會與您聯繫，提供相關諮詢服務。
        </p>
      </div>
      <CForm @submit.prevent="submit">
        <CFormFloating class="mb-3">
          <CFormInput
            id="floatingInput"
            type="text"
            placeholder="name@example.com"
            name="name"
            required
          />
          <CFormLabel for="floatingInput">
            <span class="text-danger me-2">*</span>填表人姓名
          </CFormLabel>
        </CFormFloating>
        <CFormFloating class="mb-3">
          <CFormInput
            id="floatingInput"
            type="email"
            placeholder="name@example.com"
            name="email"
            required
          />
          <CFormLabel for="floatingInput">
            <span class="text-danger me-2">*</span>電子郵件
          </CFormLabel>
        </CFormFloating>
        <CFormFloating class="mb-3">
          <CFormInput
            id="floatingInput"
            type="text"
            placeholder="name@example.com"
            name="company_phone"
            required
          />
          <CFormLabel for="floatingInput"
            ><span class="text-danger me-2">*</span>聯絡電話 (需包含分機)
          </CFormLabel>
        </CFormFloating>

        <div>
          <CButton
            type="submit"
            class="my-btn"
            color="primary"
            variant="outline"
            >送出諮詢並查看分數</CButton
          >
        </div>
      </CForm>
    </div>
    <div v-if="isSubmitted">
      <div class="score-wrapper">
        <div class="score">
          <span class="position-absolute">{{ displayScore }}</span>
          <CircleProgress
            :size="300"
            :percent="percent"
            :viewport="true"
            :show-percent="false"
            :is-gradient="true"
            :gradient="gradient"
          />
        </div>
      </div>
      <div>
        <p class="font-normal">貴公司選擇優先關注的議題為：</p>
        <div class="topic">
          {{ topic }}
        </div>
        <div v-html="description" class="des"></div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue3-circle-progress/dist/circle-progress.css'
import CircleProgress from 'vue3-circle-progress'
import { setContactInfo } from '@/api/questionnaire'
import { computed, nextTick, onMounted, ref } from '@vue/runtime-core'
import MessageBox from '@/plugins/MessageBox'

export default {
  components: {
    CircleProgress,
  },
  props: {
    score: {
      default: 100,
      type: Number,
    },
    topic: {
      default: '',
      type: String,
    },
  },
  setup(props) {
    const isSubmitted = ref(false)
    const displayScore = ref(0)
    const gradient = {
      angle: 150,
      startColor: '#FB0F00',
      stopColor: '#2BA630',
    }
    const percent = computed(() => {
      return (props.score / 600) * 100 || 0
    })

    const description = computed(() => {
      if (props.score < 200) {
        return '貴公司已經具有ESG基礎，建議公司針對ESG議題進行更深入分析，並且針對公司的優點與特色來發揮社會影響力。尤其在GRI 2021年改版之後，更強調利害關係人的回饋與對公司的影響。建議貴公司了解各項ESG相關議題如何連結到公司的策略目標，並且將重大主題與SDG連結，方能提出更具備永續發展的方針。'
      } else if (props.score < 500)
        return '貴公司已經具備ESG的運作基礎，建議貴公司開始構思如何更進一步導入ESG，並且進行標竿學習。相關議題包括: 環境面: 用電量，用水量的盤點與節能減碳措施；社會層面: 如何落實多元化的精神於員工管理制度上；公司治理層面: 對於公司管理架構，如何組建具備國際競爭力的系統運作方式等。'
      else {
        return '公司目前並沒有法規層面的要求來導入ESG，但對於未來國際市場上客戶的要求，需要特別注意品牌客戶是否會要求提供碳排放資料，簽署人權宣言，或是要求供應商配合符合ESG各項指標等。我們建議貴公司從自身產業特性出發，思考公司的特色與亮點，找出帶有特色的ESG策略'
      }
    })

    const SPEED = 1000 / 60
    function incNbrRec(i, endNbr) {
      if (i <= endNbr) {
        displayScore.value = i
        setTimeout(function () {
          incNbrRec(i + 2, endNbr)
        }, SPEED)
      } else {
        displayScore.value = endNbr
      }
    }

    let flag = false
    const submit = async (e) => {
      if (flag) return
      if (isSubmitted.value) {
        MessageBox({
          message: '您已填寫過表單，我們將在最快的時間內與您聯繫',
          showCancelButton: false,
        })
        return
      }
      const form = new FormData(e.target)

      const data = [...form.entries()].reduce((accu, cur) => {
        accu[cur[0]] = cur[1]
        return accu
      }, {})
      flag = true
      const res = await setContactInfo(data)
      flag = false
      if (res.error) {
        MessageBox({
          message: res.msg,
          showCancelButton: false,
        })
      } else {
        isSubmitted.value = true
        nextTick(() => {
          document.querySelector('.score-wrapper').scrollIntoView()
        })
        MessageBox({
          message: '感謝您提供的寶貴資訊，我們將在最快的時間內與您聯繫',
          showCancelButton: false,
        })
      }
    }

    onMounted(() => {
      document.getElementById('pretest-result').scrollIntoView()
      incNbrRec(0, props.score)
    })

    return { percent, gradient, displayScore, description, isSubmitted, submit }
  },
}
</script>

<style lang="scss" scoped>
.score-wrapper {
  padding-top: 20px;
  margin-bottom: 60px;
}
.score {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 90px;
  line-height: 123px;
  color: #187baf;
}
.topic {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px;
  gap: 20px;
  margin-bottom: 35px;

  background: #187baf;
  border-radius: 20px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  color: #ffffff;
}
.des {
  padding: 34px 24px;
  gap: 10px;
  margin-bottom: 32px;

  background: #ffe6e6;
  border-radius: 20px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
}
.my-btn {
  margin: 0 auto;
  margin-top: 58px;
  margin-bottom: 60px;
  display: block;
  min-width: 263px;
  border-radius: 20px;
}

.font-normal {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 2px;
  color: #4d4d4d;
}

.end-greeting {
  padding-top: 2rem;
  border-top: 1px solid #b1b7c1;
  p {
    margin-top: 3rem;
    margin-bottom: 2rem;
    font-family: 'Noto Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 2px;
    color: #4d4d4d;
  }
}
</style>
